export const SET_FUEL_LIST = 'SET_FUEL_LIST';
export const SET_FUEL_REMAINING_ALERT = 'SET_FUEL_REMAINING_ALERT';
export const SET_FUEL_REMAINING_ALERT_VALUES = 'SET_FUEL_REMAINING_ALERT_VALUES';
export const RESET_FUEL_REMAINING_ALERTS = 'RESET_FUEL_REMAINING_ALERTS';
export const SET_CODES_EQUIPMENT_LINK_MAPS_LIST = 'SET_CODES_EQUIPMENT_LINK_MAPS_LIST';
export const SET_CODES_EQUIPMENT_LINK_MAP_VALUES = 'SET_CODES_EQUIPMENT_LINK_MAP_VALUES';
export const RESET_CODES_EQUIPMENT_LINK_MAPS = 'RESET_CODES_EQUIPMENT_LINK_MAPS';
